import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const aksiApproval = createAsyncThunk(
  "approval/aksiApproval",
  async ({ TransaksiApprovalID, Status, Revisi }, thunkAPI) => {
    let formData = new FormData();
    formData.append("TransaksiApprovalID", TransaksiApprovalID);
    formData.append("Status", Status);
    formData.append("Revisi", Revisi);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "aksiApproval",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
export const reConfirm = createAsyncThunk(
  "approval/reConfirm",
  async ({ JRID, Status, Revisi }, thunkAPI) => {
    let formData = new FormData();
    formData.append("JRID", JRID);
    formData.append("Status", Status);
    formData.append("Revisi", Revisi);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "reConfirm",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const kirimActivity = createAsyncThunk(
  "approval/kirimActivity",
  async ({ JRID }, thunkAPI) => {
    let formData = new FormData();
    formData.append("JRID", JRID);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "kirimActivity",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const kirimShippingManifest = createAsyncThunk(
  "approval/kirimShippingManifest",
  async ({ JRID }, thunkAPI) => {
    let formData = new FormData();
    formData.append("JRID", JRID);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "kirimShippingManifest",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const kirimPermit = createAsyncThunk(
  "approval/kirimPermit",
  async ({ JRID }, thunkAPI) => {
    let formData = new FormData();
    formData.append("JRID", JRID);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "kirimPermit",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const kirimPermintaanUnit = createAsyncThunk(
  "approval/kirimPermit",
  async ({ JRID }, thunkAPI) => {
    let formData = new FormData();
    formData.append("JRID", JRID);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "kirimPermintaanUnit",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
export const approve = createAsyncThunk(
  "approval/approve",
  async ({ primary }, thunkAPI) => {
    let formData = new FormData();
    formData.append("Primary", primary);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "siapApproval",
        { Primary: primary },
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      return thunkAPI.rejectWithValue(e?.response?.data);
    }
  }
);

export const approveList = createAsyncThunk(
  "approval/approveList",
  async ({}, thunkAPI) => {
    let formData = new FormData();
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getApprovalListModel",
        {},
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getApproval = createAsyncThunk(
  "approval/get",
  async ({ menu }, thunkAPI) => {
    let formData = new FormData();
    formData.append("Menu", menu);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getListApproval",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const insertApproval = createAsyncThunk(
  "approval/insert",
  async ({ ApprovalID, JabatanID, BagianID }, thunkAPI) => {
    let formData = new FormData();

    formData.append("ApprovalID", ApprovalID);
    formData.append("JabatanID", JabatanID);
    formData.append("BagianID", BagianID);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "inputApproval",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const updateApproval = createAsyncThunk(
  "approval/insert",
  async ({ DetailApprovalID, JabatanID, BagianID }, thunkAPI) => {
    let formData = new FormData();

    formData.append("DetailApprovalID", DetailApprovalID);
    formData.append("JabatanID", JabatanID);
    formData.append("BagianID", BagianID);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "editApproval",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

const initialState = {
  message: "",
  approveList: [],
  isApproveListFetching: false,
  isApproveListSuccess: false,
  isGetFetching: false,
  isGetSuccess: false,
  isGetError: false,
  isInsertFetching: false,
  isInsertSuccess: false,
  isInsertError: false,
  isUpdateFetching: false,
  isUpdateSuccess: false,
  isUpdateError: false,
  errorMessage: "",
  approvalClient: false,
};

export const approvalSlice = createSlice({
  name: "approval",
  initialState,
  reducers: {},
  extraReducers: {
    [aksiApproval.fulfilled]: (state, { payload }) => {
      state.isAksiApprovalFetching = false;
      state.isAksiApprovalSuccess = true;
      state.aksiApproval = payload.data;
      state.message = payload.message;
      window.location.reload(false);
      state.approvalClient = true;

      return state;
    },
    [aksiApproval.rejected]: (state, { payload }) => {
      state.isAksiApprovalFetching = false;
      state.errorMessage = payload.message;
    },
    [aksiApproval.pending]: (state) => {
      state.isAksiApprovalFetching = true;
    },
    [reConfirm.fulfilled]: (state, { payload }) => {
      state.isAksiApprovalFetching = false;
      state.isAksiApprovalSuccess = true;
      state.aksiApproval = payload.data;
      state.message = payload.message;
      state.approvalClient = true;

      return state;
    },
    [reConfirm.rejected]: (state, { payload }) => {
      state.isAksiApprovalFetching = false;
      state.errorMessage = payload.message;
    },
    [reConfirm.pending]: (state) => {
      state.isAksiApprovalFetching = true;
    },

    [approveList.fulfilled]: (state, { payload }) => {
      state.isApproveListFetching = false;
      state.isApproveListSuccess = true;
      state.approvalClient = false;
      state.approveList = payload.data;
      state.message = payload.message;
      return state;
    },
    [approveList.rejected]: (state, { payload }) => {
      state.isApproveListFetching = false;
      state.errorMessage = payload.message;
    },
    [approveList.pending]: (state) => {
      state.isApproveListFetching = true;
    },

    [approve.fulfilled]: (state, { payload }) => {
      state.isApproveFetching = false;
      state.isApproveSuccess = true;
      state.message = payload.message;
      return state;
    },
    [approve.rejected]: (state, { payload }) => {
      state.isApproveFetching = false;
      state.isApproveError = true;
      state.errorMessage = payload.message;
    },
    [approve.pending]: (state) => {
      state.isApproveFetching = true;
    },
    [kirimShippingManifest.fulfilled]: (state, { payload }) => {
      state.isApproveFetching = false;
      state.isApproveSuccess = true;
      state.message = payload.message;
      window.location.reload(false);
      return state;
    },
    [kirimShippingManifest.rejected]: (state, { payload }) => {
      state.isApproveFetching = false;
      state.isApproveError = true;
      state.errorMessage = payload.message;
    },
    [kirimShippingManifest.pending]: (state) => {
      state.isApproveFetching = true;
    },
    [kirimActivity.fulfilled]: (state, { payload }) => {
      state.isApproveFetching = false;
      state.isApproveSuccess = true;
      state.message = payload.message;
      window.location.reload(false);
      return state;
    },
    [kirimActivity.rejected]: (state, { payload }) => {
      state.isApproveFetching = false;
      state.isApproveError = true;
      state.errorMessage = payload.message;
    },
    [kirimActivity.pending]: (state) => {
      state.isApproveFetching = true;
    },
    [kirimPermit.fulfilled]: (state, { payload }) => {
      state.isApproveFetching = false;
      state.isApproveSuccess = true;
      state.message = payload.message;
      window.location.reload(false);
      return state;
    },
    [kirimPermit.rejected]: (state, { payload }) => {
      state.isApproveFetching = false;
      state.isApproveError = true;
      state.errorMessage = payload.message;
    },
    [kirimPermit.pending]: (state) => {
      state.isApproveFetching = true;
    },
    [kirimPermintaanUnit.fulfilled]: (state, { payload }) => {
      state.isApproveFetching = false;
      state.isApproveSuccess = true;
      state.message = payload.message;
      window.location.reload(false);
      return state;
    },
    [kirimPermintaanUnit.rejected]: (state, { payload }) => {
      state.isApproveFetching = false;
      state.isApproveError = true;
      state.errorMessage = payload.message;
    },
    [kirimPermintaanUnit.pending]: (state) => {
      state.isApproveFetching = true;
    },

    [getApproval.fulfilled]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetSuccess = true;
      state.data = payload.data;
      state.count = payload.count;
      state.message = payload.message;
      return state;
    },
    [getApproval.rejected]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetError = true;
      state.errorMessage = payload.message;
    },
    [getApproval.pending]: (state) => {
      state.isGetFetching = true;
    },

    // INSERT
    [insertApproval.fulfilled]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertSuccess = true;
      state.message = payload.message;
      window.location.reload(false);
      return state;
    },
    [insertApproval.rejected]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertError = true;
      state.errorMessage = payload.message;
    },
    [insertApproval.pending]: (state) => {
      state.isInsertFetching = true;
    },

    // UPDATE
    [updateApproval.fulfilled]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateSuccess = true;
      state.message = payload.message;
      window.location.reload(false);
      return state;
    },
    [updateApproval.rejected]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateError = true;
      state.errorMessage = payload.message;
    },
    [updateApproval.pending]: (state) => {
      state.isUpdateFetching = true;
    },
  },
});

export const approvalSelector = (state) => state.approval;
